export default "__VITE_ASSET__645290dd__"